import type { Immutable } from 'immer';
import { AI_STATUS } from '@studio/constants/library';
import type { Shared } from '@studio/types';

const isAIEnriching = (media: Immutable<Shared.Library.BaseMediaItem> | Shared.Library.BaseMediaItem): boolean => {
  const mediaAIStatus = media.aiStatus;
  return (
    mediaAIStatus === AI_STATUS.GENERATE ||
    mediaAIStatus === AI_STATUS.REQUESTED ||
    mediaAIStatus === AI_STATUS.PARTIALLY_COMPLETED ||
    mediaAIStatus === AI_STATUS.SUBTITLES
  );
};

export default isAIEnriching;
